import { BdsAutocomplete } from 'blip-ds/dist/blip-ds-react/components';
import React, { useCallback, useEffect, useRef } from 'react';
import { AutoCompleteProps } from '../../typings/components/Autocomplete';
import './styles.scss';

export const AutoComplete: React.FC<AutoCompleteProps> = ({
    id,
    options,
    label,
    icon,
    selectedOption,
    placeholder,
    className,
    isRequired = false,
    disabled = false,
    optionsPosition = 'bottom',
    errorMessage = '',
    selectionType,
    loading = false,
    handleChange,
    handleMultiselectedChange,
}) => {
    const blipSelectRef = useRef<any>(null);

    const handleChangeAutoComplete = useCallback(
        (event: CustomEvent<any>) => {
            if (event.detail && handleChange) {
                handleChange(event.detail.value);
            }
        },
        [handleChange],
    );

    const handleMultiselectedChangeAutoComplete = useCallback(
        (event: CustomEvent<any>) => {
            if (event.detail?.value && handleMultiselectedChange) {
                handleMultiselectedChange(event.detail.value);
            }
        },
        [handleMultiselectedChange],
    );

    useEffect(() => {
        const { current } = blipSelectRef;
        if (current) {
            current.addEventListener('bdsChange', handleChangeAutoComplete);
            current.addEventListener('bdsMultiselectedChange', handleMultiselectedChangeAutoComplete);

            return () => {
                current.removeEventListener('bdsChange', handleChangeAutoComplete);
                current.removeEventListener('bdsMultiselectedChange', handleMultiselectedChangeAutoComplete);
            };
        }
    }, [handleChangeAutoComplete, handleMultiselectedChangeAutoComplete]);

    return (
        <BdsAutocomplete
            id={id}
            data-testid="data-autocomplete-test"
            ref={blipSelectRef}
            icon={icon}
            className={className}
            selectionType={selectionType}
            disabled={disabled}
            placeholder={placeholder}
            value={selectedOption}
            label={!isRequired ? label : label + ' *'}
            danger={errorMessage !== ''}
            errorMessage={errorMessage}
            optionsPosition={optionsPosition}
            loading={loading}
            options={options}
        />
    );
};
